
import { useSalaryVerificationSettings } from './useSalaryVerificationSettings';
import { useTeacherVerification } from './useTeacherVerification';

// Re-export types for backward compatibility
export type { SalaryVerificationSettings, TeacherSalaryVerification } from '@/types/salaryVerification';

export function useSalaryVerification(month: number, year: number) {
  const { settings, updateSettings } = useSalaryVerificationSettings();
  const { verification, teacherProfile, isLoading, verifyTeacher } = useTeacherVerification(month, year);

  const isVerificationRequired = settings?.is_enabled && !verification?.is_verified;
  const canAccessSalary = !settings?.is_enabled || verification?.is_verified;

  return {
    settings,
    verification,
    teacherProfile,
    isLoading,
    isVerificationRequired,
    canAccessSalary,
    updateSettings,
    verifyTeacher
  };
}
